import styled from '@emotion/styled';

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LabelText = styled.label`
  font-size: 14px;
  margin-left: 0.75rem;
  margin-bottom: 0.25rem;
`;
